import { render } from "./CreateWorkflow.vue?vue&type=template&id=bf89eaa0&scoped=true"
import script from "./CreateWorkflow.vue?vue&type=script&lang=js"
export * from "./CreateWorkflow.vue?vue&type=script&lang=js"

import "./CreateWorkflow.vue?vue&type=style&index=0&id=bf89eaa0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf89eaa0"]])

export default __exports__